/** Сообщение из ответа API: { ok: false, error: { msg, code } } */
export function getApiErrorMessage(error: unknown, fallback = 'Ошибка запроса'): string {
    const err = error as { response?: { data?: Record<string, unknown> }; message?: string };
    const data = err?.response?.data;

    if (data?.error && typeof data.error === 'object' && data.error !== null) {
        const apiError = data.error as { msg?: string; message?: string };
        if (apiError.msg) {
            return String(apiError.msg);
        }
        if (apiError.message) {
            return String(apiError.message);
        }
    }

    if (typeof data?.message === 'string' && data.message) {
        return data.message;
    }

    if (typeof data?.error === 'string' && data.error) {
        return data.error;
    }

    return err?.message || fallback;
}

export function getApiErrorDetails(error: unknown): Record<string, unknown> | undefined {
    const data = (error as { response?: { data?: { error?: { details?: Record<string, unknown> } } } })?.response?.data;
    return data?.error?.details;
}
